import skyline from './default';
import horiz from './horiz';
import ikegami from './ikegami';
import jround from './jround';

export default {
  default: skyline,
  horiz,
  ikegami,
  jround,
};
